import { Fragment, useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Helmet } from 'react-helmet';
import DOMPurify from 'dompurify';
import { format } from 'date-fns';
import Select from 'react-tailwindcss-select';
import axios from 'axios';
import { connect } from 'react-redux';
import { notify } from './components/Toast';
import { apiEndpoint } from './constants/api';
import JobCandidateTable from './components/JobCandidateTable';
import Modal from './components/Modal';
import Header from './components/Header';
import Aside from './components/Aside';
import ProdzFooter from './components/Footer';
import Nav from './components/Nav';

const connector = connect(
  (state, ownProps) => ({
    ...state.user,
    employer: state.user.currentEmployer,
  }),
  {}
);
function Job({ user, employer }) {
  const [jobData, setJobData] = useState({});
  const [jobEmployers, setJobEmployers] = useState([]);
  const [projectData, setProjectData] = useState([]);
  const [jobProjects, setJobProjects] = useState([]);
  const [isProjectOpened, setIsProjectOpened] = useState(false);
  const [isEmployerOpened, setIsEmployerOpened] = useState(false);
  const { slug } = useParams();

  const loadJobData = async (q) => {
    const { data } = await axios.post(apiEndpoint(`/admin/job/${slug}`));
    setJobData(data[0]);
  };

  const loadJobEmployerData = async () => {
    const { data } = await axios.get(
      apiEndpoint(`/admin/job/${slug}/employer`)
    );
    setJobEmployers(data);
  };

  const loadJobProjectsData = async () => {
    const { data } = await axios.get(
      apiEndpoint(`/admin/job/${slug}/employer/projects`)
    );
    setJobProjects(data);
  };

  const loadProjectData = async () => {
    try {
      const { data } = await axios.post(apiEndpoint('/search/projects'), {
        q: '',
        employer: employer.value,
      });
      setProjectData(data);
    } catch (ex) {
      console.log('ex', ex);
    }
  };

  const updateJobProjects = async () => {
    try {
      const { data } = await axios.post(
        apiEndpoint(`/admin/job/${slug}/employer/projects`),
        {
          projects: jobProjects,
          user: user.id,
        }
      );
      closeModal();
      notify('Job Projects saved successfully');
    } catch (ex) {
      console.log('ex', ex);
    }
  };

  const updateJobEmployer = async () => {
    try {
      const { data } = await axios.post(
        apiEndpoint(`/admin/job/${slug}/employer`),
        {
          employers: jobEmployers,
          user: user.id,
        }
      );
      closeModal();
      notify('Job Employers saved successfully');
    } catch (ex) {
      console.log('ex', ex);
    }
  };

  const closeModal = async () => {
    loadJobData();
    loadJobEmployerData();
    loadJobProjectsData();
    setIsEmployerOpened(false);
    setIsProjectOpened(false);
  };

  const openModal = async (key) => {
    loadProjectData();
    if (key === 'project') {
      setIsProjectOpened(true);
      setIsEmployerOpened(false);
    } else if (key === 'employer') {
      setIsEmployerOpened(true);
      setIsProjectOpened(false);
    }
  };

  useEffect(() => {
    loadJobData();
    loadJobEmployerData();
    loadJobProjectsData();
  }, []);

  return (
    <>
      <Helmet>
        <title>{`${jobData.title}`} | Job | Productions.com</title>
      </Helmet>
      <div className="min-h-full">
        <Nav />
        <>
          <Header publicId={employer.logo} />
          <Aside />
          <main className="p-4 sm:ml-64">
            <div className="mx-auto sm:px-6 lg:px-8 mb-5">
              {/* Replace with your content */}
              <div>
                <div className="w-full mb-2 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700">
                  <div className="flex gap-4">
                    {!jobData.confidential && jobData.image ? (
                      <div className="flex items-center w-20 h-20">
                        <LazyLoadImage
                          className="w-20 h-20"
                          src={`https://filmconnx-production.s3.amazonaws.com/uploads/${jobData.image}`}
                        />
                      </div>
                    ) : (
                      <></>
                    )}

                    {!!jobData.confidential ? (
                      <div className="flex items-center w-20 h-20">
                        <LazyLoadImage
                          className="w-20 h-20"
                          src={`https://res.cloudinary.com/prodz-com/image/upload/v1687275142/confidential-8cd0841b741733d249b2e71a904cde904a0e67a95fef2f125b38453ec12fc0b7_ars9ed.png`}
                        />
                      </div>
                    ) : (
                      <></>
                    )}
                    <div>
                      <div>
                        <h1 className="text-4xl text-gray-800">
                          {jobData.title}
                        </h1>
                      </div>
                      <div className="text-lg">
                        {jobData.company_name &&
                          jobData.company_name.replace('Paramount', 'Disney')}
                      </div>
                    </div>
                    <div className="grow flex-col">
                      <div className="flex justify-end">
                        {employer.value ===
                        '35d42b9e-e2f5-4070-8827-535eceb8ff12' ? (
                          <button
                            onClick={() => openModal('employer')}
                            type="button"
                            className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-lg inline-flex items-center px-5 py-2.5 text-center mr-2"
                          >
                            Edit Employer
                          </button>
                        ) : (
                          <></>
                        )}
                        <button
                          onClick={() => openModal('project')}
                          type="button"
                          className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-lg inline-flex items-center px-5 py-2.5 text-center mr-2"
                        >
                          Edit Project
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    className="text-2xl listType"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(jobData.description),
                    }}
                  />
                  <div className="py-4">
                    <div className="underline">Summary</div>
                    <div className="text-2xl">{jobData.summary}</div>
                    <hr className="h-px my-4 bg-gray-200" />
                    <div className="text-md">
                      <b>Contact</b>: {jobData.hiring_contact_name}{' '}
                      <a
                        className="text-blue-600 hover:underline"
                        href={`mailto:{jobData.hiring_contact_email}`}
                      >
                        {jobData.hiring_contact_email}
                      </a>
                    </div>
                    <div className="text-md">
                      <b>Posted</b>:{' '}
                      {jobData.job_post_date &&
                        format(new Date(jobData.job_post_date), 'MMM dd, yyyy')}
                    </div>
                    <div className="text-md font-bold">
                      {!jobData.closed
                        ? 'Acccepting Applications'
                        : 'Applications closed'}
                    </div>
                    <div className="text-md text-blue-600 hover:underline">
                      <a
                        target="_blank"
                        href={`https://productions.com/job/${jobData.slug}`}
                      >
                        Public Link
                      </a>
                    </div>
                    {employer.value ===
                    '35d42b9e-e2f5-4070-8827-535eceb8ff12' ? (
                      <div className="text-md text-blue-600 hover:underline">
                        <a
                          target="_blank"
                          href={`https://employer.productions.com/admin/job-posting/${jobData.slug}`}
                        >
                          Admin Job Link
                        </a>
                      </div>
                    ) : (
                      <></>
                    )}
                    <hr className="h-px my-4 bg-gray-200" />
                    {jobData.job_tag ? (
                      <span className="bg-blue-100 text-blue-800 text-md font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">
                        {jobData.job_tag.charAt(0).toUpperCase() +
                          jobData.job_tag.slice(1)}
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                {jobData.id && (
                  <JobCandidateTable jobId={jobData.id} jobData={jobData} />
                )}
              </div>
              {/* /End replace */}
            </div>
            <Modal
              title="Edit Job Project"
              isOpened={isProjectOpened}
              modalData={jobData}
              onClose={() => closeModal()}
            >
              <form className="w-full">
                <div className="text-lg text-left mb-5">{jobData.title}</div>
                <label
                  htmlFor="candidateStatus"
                  className="block mb-2 text-lg font-medium text-gray-900 dark:text-white text-left"
                >
                  Select a project
                </label>
                <Select
                  value={jobProjects}
                  onChange={setJobProjects}
                  options={projectData.map((p) => ({
                    value: p.id,
                    label: p.name,
                  }))}
                  classNames={{
                    menu: 'absolute z-50 w-full bg-white shadow-lg border rounded py-1 mt-1.5 text-lg text-gray-700',
                  }}
                  isMultiple
                />
                <div className="my-2">
                  <button
                    onClick={updateJobProjects}
                    type="button"
                    className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-lg inline-flex items-center px-5 py-2.5 text-center mr-2"
                  >
                    Update Project Job
                  </button>
                  <button
                    type="button"
                    onClick={closeModal}
                    className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-lg font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal>
            <Modal
              title="Edit Job Employer"
              isOpened={isEmployerOpened}
              modalData={jobData}
              onClose={() => closeModal()}
            >
              <form className="w-full">
                <div className="text-lg text-left mb-5">{jobData.title}</div>
                <label
                  htmlFor="employerStatus"
                  className="block mb-2 text-lg font-medium text-gray-900 dark:text-white text-left"
                >
                  Select an employer
                </label>
                {user.employers && user.employers.length ? (
                  <Select
                    value={jobEmployers}
                    onChange={setJobEmployers}
                    options={[...user.employers].map((e) => ({
                      value: e.org_id,
                      label: e.org_name,
                    }))}
                    classNames={{
                      menu: 'absolute z-50 w-full bg-white shadow-lg border rounded py-1 mt-1.5 text-lg text-gray-700',
                    }}
                    isMultiple
                  />
                ) : (
                  <></>
                )}
                <div className="my-2">
                  <button
                    type="button"
                    onClick={updateJobEmployer}
                    className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-lg inline-flex items-center px-5 py-2.5 text-center mr-2"
                  >
                    Update Job Employer
                  </button>
                  <button
                    type="button"
                    onClick={closeModal}
                    className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-lg font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal>
            <ProdzFooter />
          </main>
        </>
      </div>
    </>
  );
}

export default connector(Job);
